/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.8",
    versionName: "0.2.0-nightly.2026.2.8",
    versionChannel: "nightly",
    buildDate: "2026-02-08T00:13:54.082Z",
    commitHash: "3ca500d9b8e991132982687d42c5ec9e53d4998a",
};
